<template>
  <van-image :src="imageUrl" fit="cover" />
</template>
<script>
import { ProxyAliOss } from './oss.js'
export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newOss: null,
      imageUrl: ''
    }
  },
  watch: {
    newOss: {
      deep: true,
      handler() {
        this.updateUrl()
      }
    },
    src() {
      this.updateUrl()
    }
  },
  created() {
    this.newOss = ProxyAliOss
    this.updateUrl()
  },
  methods: {
    updateUrl() {
      this.imageUrl = this.newOss.ossClient
        ? this.newOss.getOssImg(this.src)
        : this.src
    }
  }
}
</script>
